export const phoneFormat = (phone) => {
	let p = phone;

	p = p.replace(/[^\d]*/gi, "");

	if (p.length < 3) {
		return p;
	} else if (p.length == 3) {
		let pp = p;
		let d4 = p.indexOf("(");
		let d5 = p.indexOf(")");
		if (d4 == -1) {
			pp = "(" + pp;
		}
		if (d5 == -1) {
			pp = pp + ")";
		}
		return pp;
	} else if (p.length > 3 && p.length < 7) {
		p = "(" + p;
		let l30 = p.length;
		let p30 = p.substring(0, 4);
		p30 = p30 + ")";

		let p31 = p.substring(4, l30);
		let pp = p30 + p31;

		return pp;
	} else if (p.length >= 7) {
		p = "(" + p;
		let l30 = p.length;
		let p30 = p.substring(0, 4);
		p30 = p30 + ")";

		let p31 = p.substring(4, l30);
		let pp = p30 + p31;

		let l40 = pp.length;
		let p40 = pp.substring(0, 8);
		p40 = p40 + "-";

		let p41 = pp.substring(8, l40);
		let ppp = p40 + p41;
		let maxphonelength = 13;
		let finalPhone = ppp.substring(0, maxphonelength);
		return finalPhone;
	}
};

// function ValidateEmail(mail) {
//   if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(myForm.emailAddr.value)) {
//     return (true)
//   }
//   alert("You have entered an invalid email address!")
//   return (false)
// }
export const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export const isValidURL = (string) => {
	let httpRegex = /^[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
	return httpRegex.test(string);
}


export function extractEmails(text) {
	return text.match(/(?:[a-z0-9+!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi);
}

export function extractPhoneNumber(numbermsg) {
	// replace all character in string with space
	let alldigit = numbermsg.replace('(', '');
	alldigit = alldigit.replace(')', '');
	alldigit = alldigit.replace(/\-/g, '');
	alldigit = alldigit.replace(/\D/g, ' ');
	// const alldigit = numbermsg.replace(/\D/g, ' ');
	// console.log(alldigit);

	// remove duplicate elements and create new array
	const phoneaaray = [...new Set(alldigit.split(' '))];

	// filter number which has length for greater than 10
	const phonenumber = phoneaaray.filter((nm, i) => (nm.length >= 10));
	return phonenumber.length ? phonenumber[0] : '';
}